import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Map } from 'immutable';
import classNames from 'classnames';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.primary.dark,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  headerContent: {
    color: theme.palette.primary.light,
    width: '100%',
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth - 1}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    color: theme.palette.primary.light,
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: 0,
    // width: theme.spacing.unit * 7 + 1,
    // [theme.breakpoints.up('sm')]: {
    //   width: theme.spacing.unit * 9 + 1,
    // },
  },
  drawerCloseBtn: {
    position: 'absolute',
    right: 5,
    top: 5,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: ({ isDesktop }) => ({
    flexGrow: isDesktop ? 1 : 1,
    padding: theme.spacing(3),
  }),
  footer: {
    marginTop: 20,
    marginBottom: 10,
  },
}));

const AppDrawer = props => {
  const { footerLogoUrl, headerContent, drawerContent, children } = props;
  const isDesktop = useMediaQuery('(min-width:1025px)');

  const classes = useStyles({ isDesktop });
  const [state, setState] = React.useState(Map({ open: isDesktop }));
  React.useEffect(() => {
    console.log('>>AppDrawer/index::', 'isDesktop', isDesktop); //TRACE
    setState(oldState => oldState.merge({ open: isDesktop }));
  }, [isDesktop]);
  const handlers = {
    handleDrawerOpen() {
      setState(oldState => oldState.merge({ open: true }));
    },
    handleDrawerClose() {
      setState(oldState => oldState.merge({ open: false }));
    },
  };
  const { open } = state.toObject();
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={classNames(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar disableGutters={!open}>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={handlers.handleDrawerOpen}
            className={classNames(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <div className={classes.headerContent}>{headerContent}</div>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={classNames(classes.drawer, {
          [classes.drawerOpen]: state.get('open'),
          [classes.drawerClose]: !state.get('open'),
        })}
        classes={{
          paper: classNames({
            [classes.drawerOpen]: state.get('open'),
            [classes.drawerClose]: !state.get('open'),
          }),
        }}
        open={state.get('open')}
      >
        <div style={{ overflowX: 'hidden' }}>
          {drawerContent}
          <div className={classes.drawerCloseBtn}>
            <IconButton onClick={handlers.handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <div className={classes.footer}>
            <center>
              <img height={175} src={footerLogoUrl} />
            </center>
          </div>
        </div>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        {children}
      </main>
    </div>
  );
};

export default AppDrawer;
